import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RiDashboardLine,
  RiUserLine,
  RiFileListLine,
  RiFileTextLine,
  RiSettings4Line,
} from "react-icons/ri";
import { logo, person } from "../assets/imagesPath";

const menuItems = [
  { icon: RiDashboardLine, label: "Dashboard", path: "/dashboard" },
  { icon: RiUserLine, label: "User Management", path: "/management" },
  { icon: RiFileListLine, label: "Quotations", path: "/quotation" },
  { icon: RiFileTextLine, label: "Invoice Management", path: "/invoice" },
  { icon: RiSettings4Line, label: "Settings", path: "/setting" },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="bg-[#173363] h-screen w-72 fixed left-0 top-0 text-white p-4 flex flex-col">
      {/* Logo Section */}
      <div className="mb-10">
        <img src={logo} alt="Logo" className="w-20 h-20 mx-auto" />
      </div>

      {/* Sidebar Menu */}
      <nav className="flex-1 space-y-6">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;

          return (
            <div
              key={item.id || item.path}
              className={`flex items-center space-x-3 p-3 font-normal text-lg leading-none tracking-normal rounded-lg cursor-pointer transition duration-300 ${
                isActive
                  ? "bg-white text-[#173363] font-semibold "
                  : "hover:bg-white hover:bg-opacity-10"
              }`}
              onClick={() => navigate(item.path)}
            >
              <item.icon
                className={`text-xl ${isActive ? "text-[#173363]" : ""}`}
              />
              <span>{item.label}</span>
            </div>
          );
        })}
      </nav>

      {/* Profile & Upgrade Section */}
      <div className="space-y-6">
        {" "}
        {/* Increased vertical gap */}
        <button className="px-12 bg-white text-[#173363] py-3 rounded-lg font-semibold ml-6">
          Upgrade Now
        </button>
        <div className="flex items-center space-x-3 p-3 bg-white bg-opacity-5 rounded-lg">
          <img src={person} alt="Profile" className="w-10 h-10 rounded-full" />
          <div className="flex-1">
            <h4 className=" font-semibold text-lg leading-none ">
              Easin Arafat
            </h4>
            <p className="text-sm text-gray-300 font-semibold text-md leading-none ">
              Free Account
            </p>
          </div>
          <button className="w-8 h-8 rounded-full bg-white bg-opacity-10 flex items-center justify-center">
            <RiSettings4Line />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
